export default {"src":"/_next/static/media/Heart Valve Disorders.1177534e.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};